import { useNavigate } from 'react-router-dom'
import { Ticket, CalendarBlank, AddressBook, Heart, BookOpen, UserPlus } from '@phosphor-icons/react'
import KioskHeader from '../../components/KioskHeader/KioskHeader'

const MODULES = [
  {
    title: 'Submit Ticket',
    desc: 'Report maintenance, facilities, or support issues.',
    path: '/submit-ticket',
    icon: Ticket,
  },
  {
    title: 'Events',
    desc: 'View upcoming community events and activities.',
    path: '/events',
    icon: CalendarBlank,
  },
  {
    title: 'Contact Directory',
    desc: 'Find management, security, facilities, and key contacts.',
    path: '/directory',
    icon: AddressBook,
  },
  {
    title: 'Say Hi',
    desc: 'Share your message and photo with the community leader.',
    path: '/support-us',
    icon: Heart,
  },

  {
    title: 'Join PBB',
    desc: 'Register your interest to join PBB N22 Kedup and let our team contact you.',
    path: '/join-pbb',
    icon: UserPlus,
  },
  {
    title: 'Resources',
    desc: 'Browse how-to guides, information categories, and PDF downloads.',
    path: '/resources',
    icon: BookOpen,
  },
]

export default function KioskHomePage() {
  const navigate = useNavigate()

  return (
    <main className="kiosk-page">
      <div className="app-container kiosk-container">
        <KioskHeader />

        <section className="kiosk-hero">
          <span className="kiosk-hero__eyebrow">Self-service kiosk</span>
          <h1>How can we help you today?</h1>
          <p>Select a module below to continue. The kiosk will return to this page automatically after inactivity.</p>
        </section>

        <section className="kiosk-module-grid">
          {MODULES.map((item) => {
            const Icon = item.icon

            return (
              <button key={item.title} type="button" className="kiosk-module-card" onClick={() => navigate(item.path)}>
                <span className="kiosk-module-card__icon"><Icon size={34} /></span>
                <span>
                  <strong>{item.title}</strong>
                  <small>{item.desc}</small>
                </span>
              </button>
            )
          })}
        </section>
      </div>
    </main>
  )
}
